import EphemeralDevice from './EphemeralDevice.js'

const axios = require('axios')
const sjcl = require('sjcl')
const aws = require('aws-sdk')

export default {
  state: {
    registeredDevices: [],
    amazonAuthenticated: false,
    integrationError: ''
  },
  getters: {
    registeredDevices: (state) => { return state.registeredDevices },
    amazonAuthenticated: (state) => { return state.amazonAuthenticated },
    integrationError: (state) => { return state.integrationError },
    getDynamoDB: (state) => {
      if (!state.amazonAuthenticated) return null
      return new aws.DynamoDB()
    },
    getSNS: (state) => {
      if (!state.amazonAuthenticated) return null
      return new aws.SNS()
    }
  },
  mutations: {
    setAmazonCredentials (state, {credentials}) {
      console.log(credentials)
      aws.config = new aws.Config(JSON.parse(credentials))
      state.amazonAuthenticated = true
    },
    setIntegrationError (state, {message}) {
      console.log(message)
      state.integrationError = message
    },
    fileDeviceRegistration (state, payload) {
      var existing = null
      for (var i = 0, il = state.registeredDevices.length; i < il; i++) {
        if (state.registeredDevices[i].key === payload.message_service_token.S) {
          existing = state.registeredDevices[i]
          break
        }
      }

      if (!existing) {
        existing = new EphemeralDevice(payload.message_service_token.S)
        state.registeredDevices.push(existing)
      }
      existing.addRegistration(payload)
    }
  },
  actions: {
    attemptAuthentication ({commit}, {password}) {
      return new Promise((resolve, reject) => {
        axios.get('/static/secret.aes')
        .then((response) => {
          try {
            var cipher = JSON.stringify(response.data)
            var plain = sjcl.decrypt(password, cipher)
            commit('setAmazonCredentials', {credentials: plain})
            resolve()
          } catch (e) {
            commit('setIntegrationError', e)
            reject(e)
          }
        }, (e) => {
          commit('setIntegrationError', e)
        })
      })
    },
    refreshRegisteredDevices ({commit, state}) {
      if (!state.amazonAuthenticated) return
      var ddb = new aws.DynamoDB()
      ddb.scan({TableName: 'RegisteredDevices'}, (err, data) => {
        if (err) {
          commit('setIntegrationError', err)
        } else {
          console.log(data)
          for (var i = 0, li = data.Items.length; i < li; i++) {
            commit('fileDeviceRegistration', data.Items[i])
          }
        }
      })
    },
    sendPushMessage ({state, commit}, {device, data}) {
      if (!state.amazonAuthenticated) return
      var sns = new aws.SNS()
      var pushPayload = {
        Message: JSON.stringify({
          default: 'dummy',
          GCM: JSON.stringify({ data: { message: JSON.stringify(data) } })
        }),
        MessageStructure: 'json',
        TargetArn: device.getActiveString('push_arn')
      }
      console.log(pushPayload)

      sns.publish(pushPayload, (err, success) => {
        if (err) {
          commit('setIntegrationError', err)
          console.log(err)
        } else {
          alert('Message Sent!')
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/ServiceIntegration.js